<template>
  <div>
    <label v-if="label"> {{ label }}</label>
    <input
      :placeholder="placeholder"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: [String],
      default: "",
    },
    type: {
      type: [String],
    },
  },
};
</script>

<style  scoped>
input {
  font-family: "Raleway", sans-serif;
  border: 0;
  outline: none;
  box-shadow: none;

  font-size: 15px;
  height: 15px;

  width: 200px;

  background: none;

  padding: 5px 0px;
  border-bottom: 2px solid rgb(46, 46, 46);
}
label {
  margin-right: 10px;
}

@media screen and (max-width: 1200px) {
  input {
    font-size: 13px;
    width: 180px;
  }
}

@media screen and (max-width: 1000px) {
  input {
    font-size: 11px;
    width: 150px;
  }
}
</style>
